<template>
  <div id="app">
    <navbar />
    <div class="content">
      <router-view />
    </div>
    <default-footer />
  </div>
</template>

<script>
import DefaultFooter from "./components/DefaultFooter";
import Navbar from "./components/Navbar";

export default {
  name: "App",
  components: { Navbar, DefaultFooter },
};
</script>

<style lang="scss">
@import "./assets/scss/main";

html,
body,
#app {
  margin: 0;
  height: 100%;
}

#app {
  font-family: $font-family-sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $font-color;
  line-height: 1.3;

  padding: 0;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1 0 auto;
  margin-top: 54px;
  padding-bottom: 80px;
  background-color: rgba(238, 238, 238, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/App.vue